module.exports = __webpack_public_path__ + "static/media/contato.e589b0d2.jpg";